import { Controller } from "@hotwired/stimulus"
import {
  Chart,
  BarController,
  BarElement,
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Tooltip,
  Legend,
} from "chart.js"

Chart.register(
  BarController, BarElement,
  LineController, LineElement, PointElement,
  LinearScale, CategoryScale,
  Tooltip, Legend,
)

// Bar chart for visit counts per weekday, with optional line overlay for avg duration.
// data-usage-by-days-chart-labels-value='["Monday","Tuesday",...]'
// data-usage-by-days-chart-visits-value='[12,8,15,...]'
// data-usage-by-days-chart-durations-value='[45.2,38.0,...]'
// data-usage-by-days-chart-visits-label-value="Visits"
// data-usage-by-days-chart-duration-label-value="Avg duration (min)"
export default class extends Controller {
  static values = {
    labels: Array,
    visits: Array,
    durations: Array,
    visitsLabel: { type: String, default: "Visits" },
    durationLabel: { type: String, default: "Avg duration (min)" },
  }

  connect() {
    const canvas = this.element.querySelector("canvas") || this.element
    const hasDurations = this.durationsValue.some((d) => d > 0)

    const datasets = [
      {
        label: this.visitsLabelValue,
        data: this.visitsValue,
        backgroundColor: "#3b82f6cc",
        borderColor: "#3b82f6",
        borderWidth: 1,
        yAxisID: "y",
        order: 2,
      },
    ]

    if (hasDurations) {
      datasets.push({
        label: this.durationLabelValue,
        data: this.durationsValue,
        type: "line",
        borderColor: "#f59e0b",
        backgroundColor: "#f59e0b20",
        borderWidth: 2,
        pointRadius: 4,
        pointBackgroundColor: "#f59e0b",
        fill: false,
        tension: 0.3,
        yAxisID: "y1",
        order: 1,
      })
    }

    const scales = {
      y: {
        beginAtZero: true,
        position: "left",
        title: { display: true, text: this.visitsLabelValue },
        ticks: { stepSize: 1 },
      },
    }

    if (hasDurations) {
      scales.y1 = {
        beginAtZero: true,
        position: "right",
        title: { display: true, text: this.durationLabelValue },
        grid: { drawOnChartArea: false },
      }
    }

    this.chart = new Chart(canvas.getContext("2d"), {
      type: "bar",
      data: { labels: this.labelsValue, datasets },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { position: "top" },
          tooltip: { mode: "index", intersect: false },
        },
        scales,
      },
    })
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }
}
